angular.module('gym.components').directive('membershipList', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/membership_list.html.slim'),
    scope: {
      contact: '=',
      memberships: '=',
      permissions: '=',
      archive: '&',
      addMembership: '&',
      reloadContact: '&',
      onMembershipRemoved: '&',
      setTab: '&'
    },
    controller: ["$scope", "$rootScope", "$stateParams", "$modal", "$timeout", "$window", "$http", "loadingAnimation", "flash", "ReactModal", "EventService", function($scope, $rootScope, $stateParams, $modal, $timeout, $window, $http, loadingAnimation, flash, ReactModal, EventService) {
      var archiveMembership, gym, onMembershipRemoved, removeMembership;
      gym = $rootScope.gym;
      $scope.isCollapsed = true;
      $scope.hasMembershipStarted = function(membership) {
        return moment(membership.start_date).isSameOrBefore(moment().tz(gym.tz), 'day');
      };
      $scope.inactiveMemberships = function() {
        return _.filter($scope.memberships, function(membership) {
          return !membership.active;
        });
      };
      $scope.getMemberships = function() {
        if ($scope.isCollapsed) {
          return _.filter($scope.memberships, function(membership) {
            return membership.active;
          });
        } else {
          return $scope.memberships;
        }
      };
      $scope.toggleList = function() {
        return $scope.isCollapsed = !$scope.isCollapsed;
      };
      $scope.displayMembershipReplacementModal = function(membership) {
        var modalInstance;
        return modalInstance = $modal.open({
          template: require('templates/components/membership/membership_replacement_modal.html.slim'),
          resolve: {
            membership: function() {
              return membership;
            },
            contact: function() {
              return $scope.contact;
            }
          },
          controller: 'MembershipReplacementModalCtrl'
        });
      };
      removeMembership = function(membership) {
        var type, url;
        loadingAnimation.show();
        type = $stateParams.contactType;
        url = `/gyms/${gym.id}/${type}/${$scope.contact.id}/memberships/${membership.id}`;
        return $http.delete(url);
      };
      onMembershipRemoved = function() {
        return $scope.reloadContact().then(function() {
          flash.success = "Membership successfully deleted";
          $scope.$emit('invoices:list:reload');
          return loadingAnimation.hide();
        });
      };
      archiveMembership = function(membership, displayBrivoDeleteWarning) {
        var cancellation_fee_status, defaultMessage, message, ref;
        cancellation_fee_status = (ref = membership.membership_cancellation) != null ? ref.cancellation_fee_status : void 0;
        defaultMessage = "Are you sure you want to remove this membership?";
        message = (function() {
          switch (false) {
            case cancellation_fee_status !== 'upcoming':
              return `${defaultMessage}\nPlease note: this will remove the cancellation fee for this membership.`;
            case cancellation_fee_status !== 'paid' && cancellation_fee_status !== 'pending':
              return `${defaultMessage}\nPlease note: The cancellation fee for this membership has already been processed.`;
            default:
              return defaultMessage;
          }
        })();
        if (displayBrivoDeleteWarning) {
          message = `${message}\n\nPlease note: deleting this membership will cancel this member, and may remove their User record on Brivo. If you wish to avoid this, please add a replacement membership before deleting this one.`;
        }
        if ($window.confirm(message)) {
          return removeMembership(membership).then(function() {
            return onMembershipRemoved();
          });
        }
      };
      $scope.onArchive = function(membership) {
        var activeMembershipsCount, displayBrivoDeleteWarning, modalInstance;
        activeMembershipsCount = _.filter($scope.contact.memberships, {
          active: true
        }).length;
        displayBrivoDeleteWarning = $scope.contact.display_brivo_membership_delete_warning && activeMembershipsCount === 1;
        if (membership.active && membership.allow_recurring_bookings && !membership.membership_cancellation) {
          loadingAnimation.show();
          return EventService.getRecurringBookings({
            membership_id: membership.id
          }).then(function(recurringBookings) {
            var modalInstance;
            loadingAnimation.hide();
            if (recurringBookings.length) {
              modalInstance = ReactModal.open({
                component: 'DeactivateRecurringBookingsModal',
                props: {
                  contact: $scope.contact,
                  membership: membership,
                  displayBrivoDeleteWarning: displayBrivoDeleteWarning,
                  recurringBookings: recurringBookings
                }
              });
              return modalInstance.then(function(params) {
                return onMembershipRemoved();
              });
            } else {
              return archiveMembership(membership, displayBrivoDeleteWarning);
            }
          }, function() {
            flash.error = 'Request could not be completed. Please try again';
            return loadingAnimation.hide();
          });
        } else {
          if (membership.signed_waiver_id) {
            modalInstance = $modal.open({
              template: require('templates/gyms/contacts/delete_linked_memberships_modal.html.slim'),
              resolve: {
                contact: function() {
                  return $scope.contact;
                },
                membership: function() {
                  return membership;
                },
                displayBrivoDeleteWarning: function() {
                  return displayBrivoDeleteWarning;
                }
              },
              controller: 'DeleteLinkedMembershipsCtrl'
            });
            return modalInstance.result.then(function(params) {
              return onMembershipRemoved();
            });
          } else {
            return archiveMembership(membership, displayBrivoDeleteWarning);
          }
        }
      };
      $scope.isMakeUpClassAvailable = function() {
        return $scope.contact.type !== 'non_attending_contact' && $scope.permissions.manage_makeup_classes;
      };
      $scope.displayMakeUpClass = function() {
        $scope.setTab({
          tab: 'attendance',
          params: {
            attendanceTab: 'make_up_classes'
          }
        });
        return $timeout(function() {
          return $scope.$emit('contact:make_up_classes:reload');
        }, 100);
      };
      return $scope.addMakeUpClass = function(membership) {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/components/membership/membership_make_up_modal.html.slim'),
          resolve: {
            membership: function() {
              return membership;
            },
            contact: function() {
              return $scope.contact;
            },
            makeUpClass: function() {
              return {};
            }
          },
          controller: 'MembershipMakeUpClassModalCtrl'
        });
        return modalInstance.result.then(function() {
          $scope.$emit('contact:make_up_classes:reload');
          return $scope.reloadContact();
        });
      };
    }]
  };
});
